<template>
  <div>
    <app-main>
      <template v-slot:main-top>
	<div class="nav-top">
          <!-- 统计 -->
	  <div class="searchdiv">
        <!-- 查询 -->

           <el-form :model="form">

	    <div class="el-row">
		<div class="el-form-item__content" 
		style="float:left;width:70%;margin-right:2%;">
		  <!-- <el-input v-model="form.waybill_code" class="input" placeholder="请输入快递号（运单号）"></el-input> -->
		  <el-input v-model="form.keywords" class="input" placeholder="订单号/快递号"></el-input>
		</div>

                <div class="el-form-item__content" style="width:18%;float:left;">
                  <el-button type="primary" size="small" @click="queryClick2">查询</el-button>
                </div>

            </div>
           </el-form>

	  </div>

	  包裹管理
	</div>

<!-- 查询 -->
        <div class="query-header">

          <el-form label-width="60px" :model="form">
		<div class="dtime">
		  <span class="dtt">下单时间</span>
		  <div class="timedv">
		    <el-date-picker
		      v-model="start_date"
		      type="datetime"
		      placeholder="选择开始日期"
		      :picker-options="pickerOptionsStart"
		      :clearable="false"
		      value-format="yyyy-MM-dd HH:mm:ss"
		      size="mini"
		      style="width: 144px"
			@focus="updateStartDate"
		    /> -<el-date-picker
		      v-model="end_date"
		      type="datetime"
		      placeholder="选择结束日期"
		      :picker-options="pickerOptionsEnd"
		      :clearable="false"
		      value-format="yyyy-MM-dd HH:mm:ss"
		      size="mini"
		      style="width: 144px"
			@focus="updateEndDate"
		    />
		  </div>
		</div>
            <el-row>
              <el-col :span="12" style="margin-right: 10px;">
                <el-form-item label="来源平台">
                  <el-select class="pfinput" placeholder="请选择" v-model="form.value" clearable @change="selectPlatform" @clear="clearFlatform">
                    <el-option v-for="(item, index) in platforms" :key="index" :value="item"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <div style="display: table;padding-left: 10px;">
                <div class="el-form-item__content">
                  <el-button type="primary" size="small" @click="queryClick">条件搜索</el-button>
                  <el-button size="small" @click="resetClick">重置</el-button>
                </div>
              </div>
            </el-row>
	    <div class="el-row" style="padding-bottom:15px;">
            </div>
          </el-form>

        </div>
      </template>

      <template v-slot:main-content>
        <div>
          <!-- <data-statistics :statusNum="statusNum"/> -->
          <order-table @menuChange="menuChange" @curChange="curChange" :orderData="orderData" :activeIndex="activeIndex" @remove="remove"/>
        </div>
      </template>
    </app-main>
  </div>
</template>

<script>
import AppMain from 'components/baseStructure/AppMain'
// import DataStatistics from './childComps/DataStatistics'
import OrderTable from './childComps/OrderTable'
import { parceList, changeOrderStatus } from 'network/api'

export default {
  inject: ['mainReload'],
  components: {
    AppMain,
    // DataStatistics,
    OrderTable
  },
  data() {
    return {
      // 初始化时间选择器 测试
        start_date: '',
        end_date: '',

      spanIndex: 0,
      options: ['全部', '待支付', '打单中', '已出单', '异常', '取消', '发货完成'],
      platforms: ['淘宝/天猫', '京东', '拼多多', '抖音','阿里巴巴',  '其他'],
      dateSelection: ['今天', '昨天', '最近7天', '最近30天'],
      form: {
        keywords: '',		// 搜索关键词
        package_no: '',		// 包裹号
        order_status: '',	// 包裹状态
        third_order_no: '',	// 三方单号
        value: '', //
        createtime: [],		// 选择时间
        package_tips: '' // 备注
        // order: '' // 单号
      },
      orderData: {},
      platform: '', // 筛选平台参数
      activeIndex: '0', // 筛选状态参数
      currentPage: '1' // 当前页
      // statusNum: {}
    }
  },
  created() {
    // 初始化时间选择器

    /*
    const dayStar = new Date()
    const dayEnd = new Date()
    dayStar.setTime(dayStar.getTime() - 24 * 3600 * 1000)
    dayEnd.setTime(dayEnd.getTime() + 24 * 3600 * 1000)
    this.start_date = dayStar.getFullYear() + '-' + (dayStar.getMonth() + 1) + '-' + dayStar.getDate()
    this.end_date = dayEnd.getFullYear() + '-' + (dayEnd.getMonth() + 1) + '-' + dayEnd.getDate()
    */

    // 初始化订单列表
    this.getList()
    // 初始化子订单数量状态
    // this.getStatusNum({ createtime: [this.start_date,this.end_date] })
  },
  methods: {
    // 改变选择订单状态
    selectChange(val) {
      switch (val) {
        case '全部':
          this.form.order_status = '0'
          break
        case '待支付':
          this.form.order_status = '1'
          break
        case '打单中':
          this.form.order_status = '2'
          break
        case '已出单':
          this.form.order_status = '3'
          break
        case '异常':
          this.form.order_status = '4'
          break
        case '取消':
          this.form.order_status = '5'
          break
        case '发货完成':
          this.form.order_status = '6'
          break
      }
    },
    // 清除选择平台
    selectClear() {
      this.form.order_status = '0'
    },
    // 平台改变 	平台:0=淘宝,1=京东,2=阿里巴巴,3=拼多多,4=抖音,5=其他
    selectPlatform (val) {
      switch (val) {
        case '淘宝/天猫':
          this.platform = '0'	//'is_tb'	
          break
        case '阿里巴巴':
          this.platform = '2'	//'is_ali'
          break
        case '拼多多':
          this.platform = '3'	//'is_pinxixi'
          break
        case '京东':
          this.platform = '1'	//'is_jd'
          break
        case '抖音':
          this.platform = '4'	//'is_dy'
          break
        case '其他':
          this.platform = '5'	//'is_others'
          break
      }
    },
    // 清除选择平台
    clearFlatform () {
      this.platform = ''
    },
    // 筛选订单列表请求
    getList() {
      parceList({
        //waybill_code: this.form.waybill_code, // 包裹号
	keywords:this.form.keywords,	//关键词
        // package_no: this.form.package_no, // 包裹号
        // third_order_no: this.form.third_order_no, // 包裹号
        createtime: [this.start_date,this.end_date],  //this.form.times, // 时间
        order_status: this.form.order_status, // 包裹状态
        // order_tips: this.form.package_tips, // 备注
        platform: this.platform, // 平台
        page: this.currentPage // 当前页
      }).then(res => {
        this.orderData = res.data
      })
    },
    // 获取不同状态子订单数量
    // getStatusNum (params) {
    //   // eslint-disable-next-line no-undef
    //   statusNum(params).then(res => {
    //     this.statusNum = res.data
    //   })
    // },
    // menu改变
    menuChange(index) {
      this.activeIndex = index
      this.form.order_status = index
      this.currentPage = '1'
      switch (index) {
        // 全部
        case '0':
          this.getList()
          break
        // 待支付
        case '1':
          this.getList()
          break
        // 打单中
        case '2':
          this.getList()
          break
        // 已出单
        case '3':
          this.getList()
          break
        // 异常
        case '4':
          this.getList()
          break
        // 取消
        case '5':
          this.getList()
          break
      }
    },
    // 分页改变
    curChange(val) {
      this.currentPage = val
      this.getList()
    },
    // 选择时间改变
    dateChange(val) {
      this.form.createtime = val
      this.spanIndex = false
      // 查询
      this.getList()
      // this.getStatusNum({ createtime: [this.start_date,this.end_date] })
    },
    // 禁用今天以后的日期
    pickerOptionsStart: {
        disabledDate: (time) => {
          return this.disabledStart(time); 
        },
    },
    pickerOptionsEnd: {
        disabledDate: (time) => {
          return this.disabledEnd(time);
        },
    },
    // 日期点击
    dateClick(index) {
      this.spanIndex = index
      var dayStar = new Date()
      var dayEnd = new Date()
      switch (index) {
        // 今天
        case 0:
          dayStar.setTime(dayStar.getTime())
          dayEnd.setTime(dayEnd.getTime() + 24 * 3600 * 1000)

          break
        // 昨天
        case 1:
          dayStar.setTime(dayStar.getTime() - 24 * 3600 * 1000)
          dayEnd.setTime(dayEnd.getTime())

          break
        // 最近7天
        case 2:
          dayStar.setTime(dayStar.getTime() - 7 * 24 * 3600 * 1000)
          dayEnd.setTime(dayEnd.getTime() + 24 * 3600 * 1000)

          break
        // 最近30天
        case 3:
          dayStar.setTime(dayStar.getTime() - 30 * 24 * 3600 * 1000)
          dayEnd.setTime(dayEnd.getTime() + 24 * 3600 * 1000)

          break
      }
          this.start_date = dayStar.getFullYear() + '-' + (dayStar.getMonth() + 1) + '-' + dayStar.getDate()
          this.end_date = dayEnd.getFullYear() + '-' + (dayEnd.getMonth() + 1) + '-' + dayEnd.getDate()

          this.getList()
          this.getStatusNum({ createtime: [this.start_date,this.end_date] })
    },
    updateStartDate(){
	this.start_date = ''
    },
    updateEndDate(){
	this.end_date = ''
    },
    // 查询
    queryClick2() {
      this.start_date = ''
      this.end_date = ''
      this.form.order_status = ''
      this.platform = ''

      this.getList()
      // this.getStatusNum({ createtime: [this.start_date,this.end_date] })
    },
    queryClick() {
      this.form.keywords = '';
      if(this.start_date == ''){
          var dayStar = new Date()
          dayStar.setTime(dayStar.getTime() - 1 * 24 * 3600 * 1000)
          this.start_date = dayStar.getFullYear() + '-' + (dayStar.getMonth() + 1) + '-' + dayStar.getDate()
      }
      if(this.end_date == ''){
          var dayEnd = new Date()
          dayEnd.setTime(dayEnd.getTime() + 24 * 3600 * 1000)
          this.end_date = dayEnd.getFullYear() + '-' + (dayEnd.getMonth() + 1) + '-' + dayEnd.getDate()
      }

      this.getList()
      // this.getStatusNum({ createtime: [this.start_date,this.end_date] })
    },
    // 重置
    resetClick() {
      this.mainReload()
    },
    // 取消订单
    remove(id) {
      changeOrderStatus({ id: id, order_status: '5' }).then(res => {
        this.getList()
        // this.getStatusNum({ createtime: [this.start_date,this.end_date] })
        this.$message({
          message: '成功',
          type: 'success'
        })
      })
    }
  }
}
</script>
<style scoped>
.input[data-v-e3bd284a]{
  width: 100% !important;
}
</style>
<style scoped src="styles/components/queryHeader.css">
</style>

<style scoped>
::v-deep .el-input__inner {
    background-color: #FFF !important;
    border-color:#fff;
    padding:3px 0px 3px 27px;
    font-size:14px;
}
::v-deep .el-form-item__content .el-input__inner {
    padding:3px 0px 3px 6px !important;
}

.dtime {
    height:40px;
    margin-bottom:10px;
}
.dtime .dtt{
    line-height:40px;
}
.timedv {
    padding:4px 0;
    float:right;
    background-color: transparent !important;
    border:1px solid #D5D5D5;
    border-radius: 4px;
    width:320px;
}
.pfinput{
    margin-left:9px;
    border:1px solid #D5D5D5;
    border-radius: 4px;
}
</style>